import { logError } from "./logs";

export default function isEmpty(str: string | undefined) {
  try {
    if (str) {
      if (str.replace(/\s/g, '')) {
        return false;
      }
      return true;
    }
    return true;
  } catch (err) {
    logError(err as Error);
    return true;
  }
}
